import { useEffect } from "react";
import "../App.css";
import { useMediaQuery } from "react-responsive";

function AboutSkills() {
  const isSmallLaptop = useMediaQuery({
    query: "(max-width: 1000px)",
  });

  useEffect(() => {
    function isVisible(elem) {
      let coords = elem.getBoundingClientRect();

      let windowHeight = document.documentElement.clientHeight;

      let topVisible = coords.top > 0 && coords.top < windowHeight + 300;

      let bottomVisible =
        coords.bottom < windowHeight + 300 && coords.bottom > 0;

      return topVisible || bottomVisible;
    }

    const lines = document.querySelectorAll(".line-animation");

    function showVisible() {
      for (let line of lines) {
        let percent = line.dataset.width;
        if (!percent) continue;

        if (isVisible(line)) {
          let width = line.getAttribute("data-width");
          line.style.width = width + "%";
        }
      }
    }

    showVisible();
    window.addEventListener("scroll", showVisible);
  }, []);

  return (
    <div
      style={{
        width: isSmallLaptop ? "70vw" : "800px",
        margin: "auto",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <h1
        style={{
          fontSize: "1.875rem",
          fontWeight: "500",
          color: "white",
          marginTop: "70px",
        }}
      >
        Языки
      </h1>

      <h2 style={{ color: "#9ca3af", fontWeight: "500" }}>Русский - Родной</h2>
      <div
        style={{
          width: "100%",
          backgroundColor: "#939393",
          height: "6px",
          borderRadius: "4px",
        }}
      >
        <div className="line-animation" data-width="100"></div>
      </div>

      <h2 style={{ color: "#9ca3af", fontWeight: "500" }}>Английский - B1</h2>
      <div
        style={{
          width: "100%",
          backgroundColor: "#939393",
          height: "6px",
          borderRadius: "4px",
        }}
      >
        <div className="line-animation" data-width="100"></div>
      </div>

      <h2 style={{ color: "#9ca3af", fontWeight: "500" }}>Французский - A1</h2>
      <div
        style={{
          width: "100%",
          backgroundColor: "#939393",
          height: "6px",
          borderRadius: "4px",
        }}
      >
        <div className="line-animation" data-width="28"></div>
      </div>
    </div>
  );
}

export default AboutSkills;
